import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import { Button } from "primereact/button";
import pica from 'pica';

const options = {
  poster: { width: 300, height: 450 },
  thumb: { width: 425, height: 223 },
  lista: { width: 768, height: 272 },
  header: { width: 1440, height: 900 },
  thumbNoverama: { width: 368, height: 204 },
  coverMobile: { width: 462, height: 260 },
  coverDesktop: { width: 1262, height: 710 },
  coverTablet: { width: 1387, height: 780 },
};

const qualityOptions = {
  veryLow: 0.2,
  low: 0.4,
  medium: 0.6,
  high: 0.8,
  veryHigh: 1,
};

const ArtExtractor = () => {
  const [imageUrl, setImageUrl] = useState('');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [selectedOption, setSelectedOption] = useState('poster');
  const [selectedQualityOption, setSelectedQualityOption] = useState('high');
  const [showCropper, setShowCropper] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [imdbId, setImdbId] = useState('');
  const [imdbImages, setImdbImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { width, height } = options[selectedOption];

  const createImage = url =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = err => reject(err);
    });

  const dataURLtoBlob = dataurl => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new Blob([u8arr], { type: mime });
  };

  const getCroppedImg = async (imgSrc, pixelCrop) => {
    const image = await createImage(imgSrc);
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    // Second canvas for resizing to exact dimensions
    const finalCanvas = document.createElement('canvas');
    finalCanvas.width = width; // Using the selected option width
    finalCanvas.height = height; // Using the selected option height
    
    // Using pica for high quality resizing
    await pica().resize(canvas, finalCanvas);

    return new Promise((resolve, reject) => {
      if (finalCanvas.toBlob) {
        finalCanvas.toBlob(
          blob => {
            if (!blob) reject(new Error('Canvas is empty'));
            else resolve(blob);
          },
          'image/webp',
          qualityOptions[selectedQualityOption] //qualityMapping[selectedOption]
        );
      } else {
        const dataUrl = finalCanvas.toDataURL('image/webp', qualityOptions[selectedQualityOption] /*qualityMapping[selectedOption]*/);
        resolve(dataURLtoBlob(dataUrl));
      }
    });
  };

  const handleDownload = async () => {
    if (!croppedAreaPixels) return;
    try {
      const blob = await getCroppedImg(imageUrl, croppedAreaPixels);
      const urlBlob = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlBlob;
      link.download = 'cropped-image.webp';
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  const getImdbImages = () => {
    if (!imdbId) return;
    
    setIsLoading(true);
    
    // URL da função Lambda
    // const lambdaUrl = 'https://iy5avqifbswcfiijq6uqnhr2im0nhhru.lambda-url.us-east-1.on.aws/';
    const lambdaUrl = 'https://qdw3x4tckt7ywuf2bthtuhs3ri0hkybf.lambda-url.us-east-1.on.aws/'
    
    // Fazendo a requisição para a função Lambda
    fetch(`${lambdaUrl}?imdbId=${imdbId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.images && Array.isArray(data.images)) {
          setImdbImages(data.images);
          console.log("Imagens carregadas com sucesso:", data.images);
        } else {
          console.error("Formato de resposta inválido:", data);
          setImdbImages([]);
        }
      })
      .catch(error => {
        console.error('Erro ao buscar imagens:', error);
        setImdbImages([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const selectImdbImage = (url) => {
    setImageUrl(url);
    setShowCropper(true);
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 10 }}>
          <label>IMDB: </label>
          <input
            type="text"
            value={imdbId}
            onChange={(e) => setImdbId(e.target.value)}
            placeholder="IMDB Code (ex: tt0120338)"
          />

          <div className="buttonSearchField">
            <Button
              label={isLoading ? 'Carregando...' : 'get images'}
              icon="pi pi-search"
              className="p-button-success mr-2"
              onClick={getImdbImages} 
              disabled={isLoading}                          
            />
          </div>
        </div>
        
        {imdbImages.length > 0 && (
          <div style={{ marginBottom: 20 }}>
            <h3>Available images:</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              {imdbImages.map((imgUrl, index) => (
                <div key={index} style={{ cursor: 'pointer' }} onClick={() => selectImdbImage(imgUrl)}>
                  <img 
                    src={imgUrl} 
                    alt={`IMDB image ${index + 1}`} 
                    style={{ width: 100, height: 'auto', objectFit: 'cover' }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <input
        type="text"
        placeholder="URL da imagem"
        value={imageUrl}
        onChange={e => setImageUrl(e.target.value)}
      />
      <select value={selectedOption} onChange={e => setSelectedOption(e.target.value)}>
        <option value="poster">Poster: 300x450</option>
        <option value="thumb">Thumb: 425x223</option>
        <option value="lista">List: 768x272</option>
        <option value="header">Header: 1440x900</option>
        <option value="thumbNoverama">Thumb (Noverama): 368x204</option>
        <option value="coverMobile">Cover Mobile: 462x260</option>
        <option value="coverDesktop">Cover Desktop: 1262x710</option>
        <option value="coverTablet">Cover Tablet: 1387x780</option>
      </select>
      <select value={selectedQualityOption} onChange={e => setSelectedQualityOption(e.target.value)}>
        <option value="veryLow">Very Low (20%)</option>
        <option value="low">Low (40%)</option>
        <option value="medium">Medium (60%)</option>
        <option value="high">High (80%)</option>
        <option value="veryHigh">Very High (100%)</option>
      </select>
      {imageUrl && showCropper && (
        <>
          <div style={{ position: 'relative', width, height, marginTop: 10 }}>
            <Cropper
              image={imageUrl}
              crop={crop}
              zoom={zoom}
              aspect={width / height}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={(area, pixels) => setCroppedAreaPixels(pixels)}
            />
          </div>
          
          <div className="buttonSearchField">
            <Button
              label="Export"
              icon="pi pi-download"
              className="p-button-success mr-2"
              onClick={handleDownload}
            />
          </div>
        </>
      )}
    </div>
);
};

export default ArtExtractor;